const scoreCls = (s) => (s == null ? "text-stone-400" : s >= 85 ? "text-emerald-700" : s >= 70 ? "text-amber-600" : "text-rose-600");

export const PortfolioMatrix = ({ templates, rows, testId = "portfolio-matrix" }) => (
  <div className="overflow-x-auto border border-[#E7E5DF] rounded-lg" data-testid={testId}>
    <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
      <thead>
        <tr className="text-left text-[11px] uppercase tracking-wider text-stone-500">
          <th className="sticky left-0 z-20 bg-stone-50 py-3 px-3 w-12 border-b border-[#E7E5DF]">Rank</th>
          <th className="sticky left-12 z-20 bg-stone-50 py-3 px-3 min-w-[220px] border-b border-r border-[#E7E5DF]">Property</th>
          <th className="bg-stone-50 py-3 px-3 min-w-[100px] border-b border-[#E7E5DF]">Cluster</th>
          {templates.map((t) => (
            <th key={t.id} className="bg-stone-50 py-3 px-3 min-w-[130px] text-right border-b border-[#E7E5DF]">
              <span className="line-clamp-2 normal-case font-semibold" title={t.name}>{t.name}</span>
            </th>
          ))}
          <th className="sticky right-24 z-20 bg-stone-50 py-3 px-3 text-right min-w-[90px] border-b border-l border-[#E7E5DF]">Average</th>
          <th className="sticky right-0 z-20 bg-stone-50 py-3 px-3 text-right min-w-[96px] border-b border-[#E7E5DF]">Completion</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.hotel_id} className="hover:bg-stone-50/60 group">
            <td className="sticky left-0 z-10 bg-white group-hover:bg-stone-50 py-3 px-3 border-b border-stone-100">
              {r.rank != null ? (
                <span className={`inline-flex items-center justify-center w-8 h-6 rounded-md text-xs font-bold font-mono ${r.rank <= 3 ? "bg-[#14532D] text-white" : "bg-stone-100 text-stone-600"}`}>#{r.rank}</span>
              ) : <span className="text-xs text-stone-300">—</span>}
            </td>
            <td className="sticky left-12 z-10 bg-white group-hover:bg-stone-50 py-3 px-3 text-sm font-medium text-stone-800 max-w-[260px] border-b border-r border-stone-100">
              <p className="truncate" title={r.hotel}>{r.hotel}</p>
              {r.city && <p className="text-[10px] text-stone-400 truncate">{r.city}</p>}
            </td>
            <td className="py-3 px-3 text-sm text-stone-500 border-b border-stone-100">{r.cluster || "—"}</td>
            {templates.map((t) => {
              const c = r.cells[t.id];
              return (
                <td key={t.id} className={`py-3 px-3 text-right border-b border-stone-100 ${c?.missed ? "bg-rose-50" : ""}`}
                  data-testid={c?.missed ? `missed-cell-${r.hotel_id}-${t.id}` : undefined}>
                  {c ? (
                    <>
                      <span className={`font-mono text-sm font-semibold ${c.missed ? "text-rose-600" : scoreCls(c.score)}`}>
                        {c.score != null ? `${c.score}%` : c.missed ? "Missed" : "—"}
                      </span>
                      <p className={`text-[10px] ${c.missed ? "text-rose-500 font-semibold" : "text-stone-400"}`}>
                        {c.missed ? (c.score != null ? `overdue · last ${c.date}` : "overdue") : c.date || "pending"}
                      </p>
                    </>
                  ) : <span className="text-xs text-stone-300">·</span>}
                </td>
              );
            })}
            <td className="sticky right-24 z-10 bg-white group-hover:bg-stone-50 py-3 px-3 text-right border-b border-l border-stone-100">
              <span className={`font-mono text-sm font-bold ${scoreCls(r.avg_score)}`}>{r.avg_score != null ? `${r.avg_score}%` : "—"}</span>
            </td>
            <td className="sticky right-0 z-10 bg-white group-hover:bg-stone-50 py-3 px-3 border-b border-stone-100">
              {r.completion_pct != null ? (
                <div className="flex items-center justify-end gap-1.5">
                  <div className="w-10 h-1.5 bg-stone-100 rounded-full">
                    <div className={`h-1.5 rounded-full ${r.completion_pct >= 80 ? "bg-emerald-500" : r.completion_pct >= 50 ? "bg-amber-500" : "bg-rose-500"}`} style={{ width: `${r.completion_pct}%` }} />
                  </div>
                  <span className="font-mono text-xs font-semibold text-stone-600 w-9 text-right">{r.completion_pct}%</span>
                </div>
              ) : <p className="text-right text-xs text-stone-300">no audits</p>}
            </td>
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={templates.length + 5} className="py-10 text-center text-sm text-stone-400">No audits found.</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
